import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { MEMBER_PROFILE_TABS } from '../constants';

const ProfileTabs = ({ activeTab, toggleTab }) => {
    return (
        <Nav
            className="border-0 gap-2 flex-nowrap overflow-auto no-scrollbar"
            style={{
                marginBottom: '0',
                paddingBottom: '0'
            }}
        >
            {MEMBER_PROFILE_TABS.map((tab) => (
                <NavItem key={tab.id} className="position-relative">
                    <NavLink
                        className={classnames({ active: activeTab === tab.id }, "border-0")}
                        onClick={() => toggleTab(tab.id)}
                        style={{
                            cursor: 'pointer',
                            backgroundColor: activeTab === tab.id ? 'rgba(255, 255, 255, 0.15)' : 'transparent',
                            color: activeTab === tab.id ? '#fff' : 'rgba(255, 255, 255, 0.65)',
                            backdropFilter: activeTab === tab.id ? 'blur(15px)' : 'none',
                            WebkitBackdropFilter: activeTab === tab.id ? 'blur(15px)' : 'none',
                            borderRadius: '0px',
                            padding: '12px 20px',
                            fontWeight: activeTab === tab.id ? '600' : '400',
                            transition: 'all 0.25s ease',
                            fontSize: '13.5px',
                            display: 'flex',
                            alignItems: 'center',
                            whiteSpace: 'nowrap',
                            borderBottom: activeTab === tab.id ? '3px solid #fff' : '3px solid transparent'
                        }}
                    >
                        <i className={`mdi ${tab.icon} me-2 font-size-17`}></i>
                        {tab.label}
                    </NavLink>
                </NavItem>
            ))}
        </Nav>
    );
};

export default ProfileTabs;
